import { NetworkStatus, RoleType } from '@bettermode/common/gql/generated'

import { SSO_CALLBACK_PATH } from '../../ssos/constants/ssos.constants.js'

const NO_AUTH_PATHS = ['/oauth/', '/auth/', '/api/analytics', SSO_CALLBACK_PATH]

export const isNoAuthPath = (path: string): boolean => {
  return NO_AUTH_PATHS.some(noAuthPath => path.startsWith(noAuthPath))
}

export const isRestricted = (
  roleType: RoleType,
  networkStatus: NetworkStatus,
  url: string,
): boolean => {
  const isAdmin = roleType === RoleType.admin
  const isUnpublished = networkStatus === NetworkStatus.unpublished
  const isArchived = networkStatus === NetworkStatus.archived

  if (isArchived && !url.startsWith('/auth/restricted')) {
    return true
  }

  // For admins everything is allowed.
  // For guests and regular members, only login page is allowed.
  const isURLAllowed =
    isAdmin ||
    url.startsWith('/auth/login') ||
    url.startsWith('/auth/restricted')

  return isUnpublished && !isURLAllowed
}

type TGenerateLoginUrl = (opts: {
  redirect?: string
  disableAutoLogin?: boolean
}) => string

export const generateLoginUrl: TGenerateLoginUrl = ({
  redirect,
  disableAutoLogin,
}) => {
  const params = new URLSearchParams()
  if (redirect) {
    params.append('redirect', redirect)
  }

  if (disableAutoLogin) {
    params.append('auto_login', 'false')
  }
  const query = params.toString()
  return `/auth/login${query.length ? `?${query}` : ''}`
}

export const generateMemberVerificationUrl = (
  memberId: string,
  redirectPath?: string,
): string => {
  const params = new URLSearchParams({
    memberId,
  })
  if (redirectPath) {
    params.append('redirect', redirectPath)
  }

  return `/auth/verify?${params.toString()}`
}
